module.exports = __webpack_public_path__ + "static/img/file_ppt.74606fc4.png";